module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-10-5638ae5445f33ce731fac166315fb006.png";